/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dlh_DetectedInputs */

const en_wc_dlh_detected = /** @type {(inputs: Wc_Dlh_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your system`)
};

/**
* | output |
* | --- |
* | "Your system" |
*
* @param {Wc_Dlh_DetectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dlh_detected = /** @type {((inputs?: Wc_Dlh_DetectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dlh_DetectedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dlh_detected(inputs)
});
export { wc_dlh_detected as "wc.dlh.detected" }